import React, { useEffect, useState } from "react";
import {
  Container,
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom"; // optional if using React Router
import { useT } from "contexts/TranslationContext";
import Subscription from "./Subscription";
const PRIMARY_GREEN = '#4CAF50';

export default function PaymentPage() {
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); // if not using React Router, you can replace with window.location.href
  const t = useT();
  const [price, setPrice] = useState(0);
  

  useEffect(() => {
    const savedPlan = localStorage.getItem("selectedPlan");
    if (savedPlan) {
      try {
        setPlan(JSON.parse(savedPlan));
      } catch {
        console.error("Invalid plan data");
        navigate("/pricing");
      }
    } else {
      navigate("/dashboard");
    }
    setLoading(false);
  }, [navigate]);

  

  const handleBack = () => {
    navigate("/pricing");
  };


  function getPlanPrice(plan) {
    switch (plan) {
      case "premium":
        return 49;
      case "business":
        return 29;
      default:
        return 9;
    }
  }
  
  useEffect(() => {
    if (plan) {
      const planPrice = getPlanPrice(plan);
      setPrice(planPrice);
    }
  }, [plan]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="80vh">
        <CircularProgress />
      </Box>
    );
  }
  // if (!plan) return null;

  return (
    <Container maxWidth="sm">
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="90vh"
      >
        <Card sx={{ width: "100%", p: 3, borderRadius: 3, boxShadow: 3 }}>
          <CardContent sx={{ textAlign: "center" }}>
            <Typography variant="h5" gutterBottom>
              {t('payment.confirm')}
            </Typography>

            <Box
              sx={{
                bgcolor: "#f9f9f9",
                p: 2,
                borderRadius: 2,
                mb: 3,
                textAlign: "left",
              }}
            >
              <Typography variant="h6" textTransform="">
                {t(`plan.${plan}`)} {t('payment.plan')}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {t('payment.billing')}: {t('payment.monthly')}
              </Typography>
              <Typography variant="subtitle1" sx={{ mt: 1, fontWeight: "bold" }}>
                {t('payment.price')}:{" "}
                {`€${price} / ${t('payment.month')}`}
              </Typography>
            </Box>

            <Subscription paymentAmount={price} />
            <br />
            <Button
                variant="outlined"
                size="large"
                href={`register/${plan.type}`}
                sx={{
                    borderColor: PRIMARY_GREEN,
                    color: PRIMARY_GREEN,
                    '&:hover': {
                        borderColor: '#2d845e',
                        bgcolor: 'rgba(52, 152, 108, 0.05)',
                    },
                    width: '175px',
                    mt: 2,
                    py: 1.5,
                    borderRadius: '8px',
                    fontWeight: 600,
                    textTransform: 'none',
                }}
                aria-label={`Select ${plan.title} plan`}
                onClick={handleBack}
            >                
              {t("payment.back")}
            </Button>

          </CardContent>
        </Card>
      </Box>
    </Container>
  );
}
